<mat-form-field style="width: 100%" class="input-yaca" [ngClass]="{ 'address-invalido': isInvalid }">
  <mat-label>Domicilio comercial*</mat-label>
  <input
    #input
    matInput
    placeholder="{{ 'pages.profile.labels.address' | translate }}"
    [matAutocomplete]="auto"
    [(ngModel)]="inputValue"
    maxlength="255"
    (paste)="checkPaste($event)"
    (drop)="checkDrop($event)"
    (keypress)="checkPattern($event)"
  />
  <!-- <button tabindex="2" type="button" mat-button matSuffix mat-icon-button aria-label="Clear" (click)="cleanLocationInputEvent(true)"><mat-icon>close</mat-icon></button> -->
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option *ngFor="let place of placesCollection" [value]="place">
      <img class="google__pin_img" aria-hidden [src]="place.icon" height="25" alt="Pin" />
      <span>{{ place.label }}</span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
